import { getUSPBanner, getUSPBannerData } from '@finn/auto-ui/utils/plp';
import { getInitialFilterKeysMap } from '@finn/ua-vehicle';
import { useUniversalRouter } from '@finn/ui-utils';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

export const useGetUSPBanner = ({
  pageData,
  initialFilter,
  totalVehiclesCount,
  nextAvailableFilters,
  allAvailableFilters,
  shouldConsiderAsLandingPageProp,
}) => {
  const [uspBannerObject, setUspBannerObject] = useState(null);
  const router = useUniversalRouter();
  const searchParams = useSearchParams();
  const campaign = router?.query?.campaign || searchParams.get('campaign');

  useEffect(() => {
    if (campaign && !shouldConsiderAsLandingPageProp) {
      const templateData = getUSPBannerData(
        initialFilter,
        totalVehiclesCount,
        nextAvailableFilters.min_price,
        getInitialFilterKeysMap(allAvailableFilters)
      );

      const campaignName = (campaign as string).toLowerCase();

      getUSPBanner(pageData, templateData, campaignName).then((data) => {
        setUspBannerObject(data);
      });
    } else {
      setUspBannerObject(null);
    }
  }, [campaign]);

  return uspBannerObject;
};
